import { Switch } from "@tremor/react";
import type { Dispatch, SetStateAction } from "react";

interface ModulesTabProps {
	modules: Array<{
		key: string;
		name: string;
		description?: string | null;
	}>;
	selectedKeys: string[];
	setSelectedKeys: Dispatch<SetStateAction<string[]>>;
	emptyText?: string;
}

const ModulesTab = ({
	modules,
	selectedKeys,
	setSelectedKeys,
	emptyText = "Δεν υπάρχουν διαθέσιμες επεκτάσεις",
}: ModulesTabProps) => (
	<>
		<div className="mb-3 flex items-center justify-between">
			<span className="text-sm font-medium text-gray-700">Διαθέσιμες Επεκτάσεις</span>
			<span className="text-sm text-gray-500">
				{selectedKeys.length}/{modules.length} ενεργές
			</span>
		</div>
		{modules.length === 0 ? (
			<p className="text-sm text-gray-500">{emptyText}</p>
		) : (
			<div className="space-y-2">
				{modules.map((mod) => {
					const isEnabled = selectedKeys.includes(mod.key);
					return (
						<div
							key={mod.key}
							className="flex items-center justify-between rounded-md border border-gray-200 px-4 py-3"
						>
							<div>
								<p className="text-sm text-gray-700">{mod.name}</p>
								{mod.description && (
									<p className="text-xs text-gray-500">{mod.description}</p>
								)}
							</div>
							<Switch
								checked={isEnabled}
								onChange={(enabled) => {
									if (enabled) {
										setSelectedKeys((prev) =>
											prev.includes(mod.key) ? prev : [...prev, mod.key],
										);
									} else {
										setSelectedKeys((prev) =>
											prev.filter((featureKey) => featureKey !== mod.key),
										);
									}
								}}
							/>
						</div>
					);
				})}
			</div>
		)}
	</>
);

export default ModulesTab;
